function initMenu() {
	const mainNav = document.getElementById("main-nav"),
		mainMenuToggler = document.getElementById("main-nav-toggler"),
		navbar = document.getElementById("smx-wrapper-navbar"),
		subPrimaryNavs = document.querySelectorAll('.dropdown-toggle'),
		htmlTag = document.getElementsByTagName("html")[0];

	mainMenuToggler.addEventListener("click", () => {
		let isOpen = mainNav.classList.contains("open");
		if (isOpen) {
			mainMenuToggler.setAttribute("aria-expanded", "false");
			mainNav.classList.remove("open");
			htmlTag.classList.remove("no-scroll");
		} else {
			mainMenuToggler.setAttribute("aria-expanded", "true");
			mainNav.classList.add("open");
			htmlTag.classList.add("no-scroll");
		}
	});

	window.addEventListener("scroll", function () {
		var scrollTop = document.documentElement.scrollTop;
		if (scrollTop >= 150) {
			navbar.classList.add("scrolled");
		} else {
			navbar.classList.remove("scrolled");
		}
	});

	if(subPrimaryNavs.length > 0){
		subPrimaryNavs.forEach((elem) => {
			elem.addEventListener("click", function (event) {
				event.preventDefault();

				subPrimaryNavs.forEach((otherElem) => {
					if (otherElem !== elem) {
						otherElem.parentElement.classList.remove('open');
					}
				});
				
				if(elem.parentElement.classList.contains('open')){
					elem.parentElement.classList.remove('open');
				} else {
					elem.parentElement.classList.add('open');
				}
			});
		});
	}
}

export default { initMenu };
